import * as Coupon from './coupon'
import type { ICoupon } from './types'

export const YEARLY_PRICE = 49.99
export const MONTHLY_PRICE = 2.99

export const MONTHLY_PLAN_CODE =
  process.env.NODE_ENV === 'development'
    ? 'price_0JO6SwW2XabqaGviDO8k1fY2'
    : 'price_0JO6gPW2XabqaGvioT95ENFR'

export function getBasePriceString(term?: string): string {
  if (term) {
    const price = getTermPrice(term)
    return formatPrice(price)
  } else {
    return formatPrice(YEARLY_PRICE)
  }
}

export function getDiscountedPriceString(
  term?: string,
  coupon?: ICoupon
): string {
  if (term && coupon) {
    const price = getTermPrice(term)
    return formatPrice(Coupon.getPrice(price, coupon))
  }
  if (coupon) {
    return formatPrice(Coupon.getPrice(YEARLY_PRICE, coupon))
  } else {
    return getBasePriceString()
  }
}

export function getDiscountString(coupon?: ICoupon): string | undefined {
  if (!coupon) {
    return
  }

  switch (coupon.discount.type) {
    case 'percent':
      return formatPercent(coupon.discount.value)
    case 'absolute':
      return formatPrice(coupon.discount.value)
  }
}

function getTermPrice(term: string): number {
  return term === 'monthly' ? MONTHLY_PRICE : YEARLY_PRICE
}

function formatPrice(value: number): string {
  return '$' + value.toFixed(2)
}

function formatPercent(value: number): string {
  return Math.round(value) + '%'
}
